"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoPopover = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../../gen-src/Localize");
var Info_14px_small_1 = require("../../img/Info_14px_small");
var InfoPopover = function (props) {
    var popoverInstance = React.useRef(null);
    var SpanButtonClass = (0, typestyle_1.style)({
        $nest: {
            '&:hover': {
                stroke: '#3498DB',
                strokeWidth: '0.1',
                filter: 'drop-shadow(1px 1px 2px rgb(0 0 0 / 0.4))',
            },
        },
    });
    var ContentStyle = {
        overflow: 'hidden',
        whiteSpace: 'normal',
        lineHeight: '1',
    };
    return (React.createElement(widgets_1.PopoverWidget, { alertType: widgets_1.PopoverAlertType.Info, title: props.title, placement: "right", width: 400, ref: popoverInstance, footerButtons: [{ children: Localize_1.Messages.okay(), buttonType: widgets_1.ButtonType.Primary, onClick: function () { var _a; return (_a = popoverInstance.current) === null || _a === void 0 ? void 0 : _a.toggle(false); } }], popoverContent: React.createElement("p", { style: ContentStyle }, props.description), triggerElement: React.createElement("span", { className: SpanButtonClass, role: "button" },
            React.createElement(Info_14px_small_1.InfoSmall, null)) }));
};
exports.InfoPopover = InfoPopover;
exports.default = exports.InfoPopover;
//# sourceMappingURL=InfoPopover.js.map